import React, { useMemo } from 'react';
import { Layout } from 'antd';
import { Routes, Route } from 'react-router-dom';
import { createRoutes } from '../routes';
import useSession from '@hooks/useSession';

const { Content } = Layout;

const FrontPage = () => {
  const { isAdmin, isSuperAdmin, isManager, isUser } = useSession();

  // Compute routes synchronously so there is never a render with an empty route list.
  // Previously this used useState([]) + useEffect, which caused a one-render window
  // where routes were empty — React Router found no match and the Approver saw a blank
  // screen (or a transient 404) before the effect fired.
  const routes = useMemo(() => {
    const isApproverOnly = isAdmin && !isUser && !isSuperAdmin;
    const isReporterOnly = isManager && !isUser && !isAdmin && !isSuperAdmin;
    let defaultPath = '/file-upload-logs';                    // Preparer / SuperAdmin
    if (isReporterOnly) defaultPath = '/spp-reports-invoice-amounts';
    else if (isApproverOnly) defaultPath = '/prod-stat-dashboard';
    return createRoutes(defaultPath);
  }, [isAdmin, isSuperAdmin, isManager, isUser]);

  return (
    <Layout
      style={{ minHeight: '100vh' }}
    >
      <Layout>
        <Content
          style={{ margin: '0', overflow: 'auto' }}
        >
          <Routes>
            {routes.map((route, idx) => (
              <React.Fragment key={route.path || idx}>
                <Route element={route.element} path={route.path || '/'} />
              </React.Fragment>
            ))}
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default FrontPage;
